import {Box, Card, CardContent, Container, Typography} from "@mui/material";
import {
  FileFragmentFragment,
  FileType,
  ZyusetuFieldSectionFragmentFragment,
  ZyusetuType,
} from "@/graphql/graphql";
import {useState} from "react";
import {FileUploader} from "@/components/pages/zyusetu-new/FileUploader";
import {AnalyzeResult} from "@/components/pages/zyusetu-new/AnalyzeResult";
import ByLawExtractorImage from "@/assets/images/bylaw-extractor.png"
import {Link} from "react-router-dom";

export function ManagementBylawExtractor() {
  const [file, setFile] = useState<FileFragmentFragment | null>();
  const [analyzeResult, setAnalyzeResult] = useState<ZyusetuFieldSectionFragmentFragment[] | null>();
  
  const handleAnalyzeComplete = (result: ZyusetuFieldSectionFragmentFragment[], uploadedFile: FileFragmentFragment) => {
    setAnalyzeResult(result);
    setFile(uploadedFile);
  };
  
  const fileType = {
    type: FileType.ManagementBylaw,
    label: "管理規約",
    description: "管理規約のPDFファイルをアップロードしてください",
    zyusetuType: ZyusetuType.InternalManagementBylaw,
  };
  
  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{my: 4}}>
          <Typography variant="h4" component="h1" gutterBottom>
            管理規約データ抽出ツール
          </Typography>
          <Typography>
            出力内容のご要望がありましたら、お気軽に<Link to={"/contact"}>問い合わせフォーム</Link>よりお問い合わせください。<br/>
            月30件まで無料でご利用いただけます。<Link to={"/usage"}>利用状況</Link>をご確認ください。
          </Typography>
        </Box>
        {!analyzeResult ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"100%"}
          >
            <Box width={'100%'}>
              <Typography fontWeight={"bold"} mb={2} mt={10}>
                管理規約のPDFファイルをアップロードしてください
              </Typography>
              <Box>
                <FileUploader
                  fileType={fileType}
                  onAnalyzeComplete={handleAnalyzeComplete}
                  zyusetuType={ZyusetuType.InternalManagementBylaw}
                />
              </Box>
              <Card sx={{mt: 4}}>
                <CardContent>
                  <Typography fontWeight={"bold"} mb={2} whiteSpace={'pre-wrap'}>
                    以下のように、売買の重説に必要な情報を管理規約のPDFから抽出します。
                  </Typography>
                  <img
                    style={{height: "480px", width: "100%", objectFit: "contain"}} src={ByLawExtractorImage}/>
                </CardContent>
              </Card>
            </Box>
          </Box>
        ) : (
          <Container
            maxWidth={"xl"}
            sx={{
              width: "100%",
              height: "100%",
            }}
          >
            <Box mb={5}>
              <Typography mb={2}>AIスマート重説の有料プランでは、動画のように参照した部分を自動でハイライトする機能を搭載しております。<br/>これにより、作成した書類を確認する工数も大幅に削減することができます。</Typography>
              <iframe width="700" height="415" src="https://www.youtube.com/embed/_BYfGAAwaHw?si=xeZLriCu2Z029Bag"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin" allowFullScreen/>
              <Typography mb={1} mt={5} variant={'h6'} fontWeight={'bold'}>{file?.fileName}</Typography>
            </Box>
            <AnalyzeResult copyValue sections={analyzeResult} file={file!}/>
          
          </Container>
        )}
      </Container>
    </>
  );
}
